import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=c38465b4&"
import script from "./PortfolioPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports